var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"pop-up message"},[_c('div',{staticClass:"img",class:_vm.message.status == 'ok' ? 'check' : 'error'}),_c('h4',[_vm._v(_vm._s(_vm.message.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }